//SECTION CHECKBOX

import { gql, useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import * as yup from 'yup';
import { addMessage, resetMessage } from "../../../../../stores/ReactiveVariables";
import { AccordionCheckbox } from "../AccordionCheckbox";

const GET_COVER_LETTER_REPORTING_PLAN_SECTION = gql`
    query GetCoverLetterReportingPlan($Id: uniqueidentifier = "") {
        BidQuotes_by_pk(Id: $Id) {
            CoverLetterReportingPlan
        }
    } 
`;

const UPDATE_COVER_LETTER_REPORTING_PLAN_SECTION = gql`
    mutation UpdateCoverLetterReportingPlanSection($Id: uniqueidentifier = "", $CoverLetterReportingPlan: Boolean = false) {
        update_BidQuotes_by_pk(pk_columns: {Id: $Id}, _set: {CoverLetterReportingPlan: $CoverLetterReportingPlan}) {
            __typename
            Id
        }
    }
`;

interface ReportingPlanCheckboxProps{
    id: string;
    getCoverLetter: () => void;
}

const validationSchema = yup.object().shape({
    CoverLetterReportingPlan: yup.boolean(),
});

export const ReportingPlanCheckbox: React.FC<ReportingPlanCheckboxProps> = ({ id, getCoverLetter }: ReportingPlanCheckboxProps) => {    
    const { data, loading, error } = useQuery(GET_COVER_LETTER_REPORTING_PLAN_SECTION, { variables: { Id: id } });
    const [updateCoverLetterExecutionPlan] = useMutation(UPDATE_COVER_LETTER_REPORTING_PLAN_SECTION);

    const formData = data?.BidQuotes_by_pk;
    
    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: validationSchema,
        initialValues: {
            CoverLetterReportingPlan: formData?.CoverLetterReportingPlan ?? false,
        },
        onSubmit: (values: any) => {
            updateCoverLetterExecutionPlan({
                variables: { Id: id, CoverLetterReportingPlan: values.CoverLetterReportingPlan },
                onCompleted: (data: any) => {
                    resetMessage();
                    const confirmMessage = values.CoverLetterReportingPlan === true ? "Reporting Plan Added To Cover Letter" : "Reporting Plan Removed From Cover Letter";
                    addMessage(confirmMessage, { severity: 'success' });
                    getCoverLetter();
                },
                onError: () => {
                    addMessage('Error Saving/Removing Purpose', { severity: 'error' });
                }
            });
        }
    });
    return (
        <AccordionCheckbox 
            getCoverLetter={getCoverLetter}
            name="CoverLetterReportingPlan"
            checked={formik.values.CoverLetterReportingPlan}
            onCheckboxClick={()=> formik.setFieldValue('CoverLetterReportingPlan', !formik.values.CoverLetterReportingPlan)}
            onSave={formik.submitForm}
            loading={loading}
        />
    )
}

